import PropTypes from 'prop-types';
import React from 'react';
import * as ColumnTypes from './ColumnTypes';
import NativeValueInput from './NativeValueInput';
import StringValueInput from './StringValueInput';

const ValueInput = props => {
  switch (props.column && props.column.type) {
    case ColumnTypes.STRING:
      return <StringValueInput {...props} />;
    case ColumnTypes.DATE:
      return <NativeValueInput type="date" {...props} />;
    case ColumnTypes.DATETIME:
      return <NativeValueInput type="datetime-local" {...props} />;
    default:
      return <NativeValueInput type="text" {...props} />;
  }
};

ValueInput.propTypes = {
  column: PropTypes.object,
};

export default ValueInput;
